import React, { useRef, useState, useEffect } from 'react'
import Cookies from 'js-cookie';

import { getAdminApi, mediaUpload, updateAdminApi } from '../../api/usersApi';
import ImageEditorBox from '../../components/ImageEditorBox/ImageEditorBox';

import dummyFounder from '../../assets/images/dummyFounder.png'

const General = ({ setShowNotification, setNotificationMessage }) => {

    const profileInputRef = useRef(null);
    const existingCookie = Cookies.get('userData');
    let userData = existingCookie ? JSON.parse(existingCookie) : {};

    const [name, setFirstName] = useState(userData?.name || '');
    const [lastName, setLastName] = useState(userData?.lastName || '');
    const [email, setEmail] = useState(userData?.email || '');
    const [showCropper, setShowCropper] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [croppedImageUrl, setCroppedImageUrl] = useState(null);
    const [isImageLoading, setImageIsLoading] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [isImageDragging, setIsImageDragging] = useState(false);
    const [isSaveLoading, setIsSaveLoading] = useState(false);
    const [mediaId, setMediaId] = useState();
    const [errorMessage, setErrorMessage] = useState({
        firstNameError: '',
        lastNameError: '',
        emailErrorMessage: '',
        alreadyUsedEmail: '',
        imageErrorMessage: '',
        validEmail: '',
    })
    const emailPattern = /^[^@\s]+@ivycorn\.[^@\s]+$/;

    const handleImageGalleryUpload = async (e) => {
        const file = e.target.files[0];

        if (!file) return;

        const validTypes = ['image/jpeg', 'image/png'];
        if (!validTypes.includes(file.type)) {
            setIsImageDragging(false)
            return;
        }
        const reader = new FileReader();
        reader.onloadend = () => {
            setSelectedImage(reader.result);
            setShowCropper(true);

            if (profileInputRef.current) {
                profileInputRef.current.value = '';
            }
        };
        reader.readAsDataURL(file);
    };

    useEffect(() => {
        fetchAdminData();
    }, []);

    const fetchAdminData = async () => {
        try {
            const token = Cookies.get('admin_token');
            const response = await getAdminApi({
                adminId: userData?.adminId,
                token,
            });
            setFirstName(response?.name);
            setLastName(response?.lastName);
            setEmail(response?.email);
            setCroppedImageUrl(response?.profileImg || '')
        } catch (error) {
            console.error('Failed to fetch admin data:', error);
        }
    };

    const handleMeidaUpload = async (file) => {
        if (file) {
            const token = Cookies.get('admin_token');
            setImageIsLoading(true)
            const formData = new FormData();
            formData.append('file', file)
            try {
                const resData = await mediaUpload(formData, token);
                setCroppedImageUrl(resData?.url)
                if (resData) {
                    setMediaId(resData?.id || '');
                }
                setImageIsLoading(false)
            } catch (error) {
                console.log({ error })
                setImageIsLoading(false)
            }
        }
    }

    const handleCropDone = async (blob) => {
        const file = new File([blob], 'cropped-image.jpg', { type: 'image/jpeg' });

        const previewUrl = URL.createObjectURL(file);
        setCroppedImageUrl(previewUrl);
        setErrorMessage(prev => ({ ...prev, imageErrorMessage: '' }));
        await handleMeidaUpload(file);
        setShowCropper(false);
    };

    const updateData = async () => {
        setIsSaveLoading(false)
        setShowNotification(false);
        let success = false;
        const rememberMe = Cookies.get('rememberMe') === 'true';
        try {
            setIsSaveLoading(true)
            success = await updateAdminApi({
                adminId: userData?.adminId,
                data: {
                    name: name,
                    lastName: lastName,
                    email: email,
                    mediaId: mediaId,
                }
            });
            if (success) {
                userData = {
                    ...userData,
                    name: name,
                    lastName: lastName,
                    email: email,
                    profileImg: croppedImageUrl
                };
                if (rememberMe && userData?.expiry) {
                    const expiryDate = new Date(userData?.expiry);
                    Cookies.set('userData', JSON.stringify(userData), { expires: expiryDate });
                } else {
                    Cookies.set('userData', JSON.stringify(userData));
                }

                setShowNotification(true);
                setNotificationMessage('Your changes have been successfully saved.');
                await fetchAdminData();
                setTimeout(() => {
                    setShowNotification(false);
                }, 8000);
                setIsSaveLoading(false)
                // setCroppedImageUrl(null)
                return true
            } else {
                setIsSaveLoading(false)
            }
            return true;
        } catch (error) {
            // setErrorMessage(prev => ({ ...prev, imageErrorMessage: 'Please upload profile image.' }));
            const errMsg = error?.response?.data?.message;
            if (errMsg?.toLowerCase().includes("email")) {
                setErrorMessage((prev) => ({
                    ...prev,
                    alreadyUsedEmail: errMsg,
                }));
            }
            setIsSaveLoading(false)
            return false;
        }
    }

    const handleSave = async () => {
        const newErrors = {
            firstNameError: '',
            lastNameError: '',
            emailErrorMessage: '',
            alreadyUsedEmail: '',
            imageErrorMessage: '',
            validEmail: '',
        };
        let isValid = true;
        if (!name?.trim()) {
            newErrors.firstNameError = 'Please fill first name.';
            isValid = false;
        }
        if (!lastName?.trim()) {
            newErrors.lastNameError = 'Please fill last name.';
            isValid = false;
        }
        if (!email?.trim()) {
            newErrors.emailErrorMessage = 'Please fill email address.';
            isValid = false;
        }
        if (!croppedImageUrl?.trim()) {
            newErrors.imageErrorMessage = 'Please upload profile image.';
            isValid = false;
        }
        if (email?.length > 0) {
            if (!emailPattern?.test(email)) {
                newErrors.validEmail = 'Email address must be an Ivycorn email.';
                isValid = false;
            }
        }
        if (!isValid) {
            setErrorMessage(newErrors);
            return;
        }
        setIsSaveLoading(true);

        await updateData();
    };

    return (
        <>
            <div className='general-section'>
                <div className="field-block">
                    <div className="label">Full name</div>
                    <div className='name-field'>
                        <div className={`input-group  ${name ? 'filled' : ''}${errorMessage?.firstNameError && 'show-error update-input-group'}`}>
                            <input type="text" id='name' className='' name='name' autoComplete="off" value={name} onChange={(e) => {
                                setFirstName(e.target.value);
                                if (errorMessage?.firstNameError) setErrorMessage(prev => ({ ...prev, firstNameError: '' }));
                            }} />
                            <label className="update-input-label" htmlFor="name">First name</label>
                            {errorMessage?.firstNameError && <p className="error-message update-input-error">{errorMessage?.firstNameError}</p>}
                        </div>
                        <div className={`input-group  ${lastName ? 'filled' : ''}${errorMessage?.lastNameError && 'show-error update-input-group'}`}>
                            <input type="text" id='lastName' className='' name='lastName' autoComplete="off" value={lastName} onChange={(e) => {
                                setLastName(e.target.value)
                                if (errorMessage?.lastNameError) setErrorMessage(prev => ({ ...prev, lastNameError: '' }));
                            }} />
                            <label className="update-input-label" htmlFor="lastName">Last name</label>
                            {errorMessage?.lastNameError && <p className="error-message update-input-error">{errorMessage?.lastNameError}</p>}
                        </div>
                    </div>
                </div>
                <div className="field-block">
                    <div className="label">Email address</div>
                    <div className='email-field'>
                        <div className={`input-group ${email ? 'filled' : ''}${errorMessage?.emailErrorMessage && 'show-error'}`}>
                            <input type="email" id='email' className='' name='email' autoComplete="off" value={email} onChange={(e) => {
                                setEmail(e.target.value)
                                if (errorMessage?.emailErrorMessage || errorMessage?.alreadyUsedEmail || errorMessage?.validEmail) setErrorMessage(prev => ({ ...prev, emailErrorMessage: '', alreadyUsedEmail: '', validEmail: '' }));
                            }} />
                            <label className="update-input-label" htmlFor="email">Email address</label>
                        </div>
                        {errorMessage?.emailErrorMessage && <p className="error-message update-input-error">{errorMessage?.emailErrorMessage}</p>}
                        {errorMessage?.alreadyUsedEmail && <p className="error-message update-input-error">{errorMessage?.alreadyUsedEmail}</p>}
                        {errorMessage?.validEmail && <p className="error-message update-input-error">{errorMessage?.validEmail}</p>}
                    </div>
                </div>
                <div className="field-block">
                    <div className="label">Profile picture</div>
                    <div className='profile-field'>
                        <div className="profile-image-section" onClick={() => {
                            profileInputRef.current?.click();
                        }}>
                            <img src={croppedImageUrl} alt="" />
                        </div>
                        <input type="file" ref={profileInputRef} id="profile-image" accept="image/png, image/jpeg" hidden onChange={handleImageGalleryUpload} />

                        <div className="image-upload-block" onClick={() => {
                            profileInputRef.current?.click();
                        }}
                            onDragOver={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (!isDragging) {
                                    setIsImageDragging(true);
                                }
                            }}
                            onDragLeave={(e) => {
                                e.preventDefault();
                                setIsImageDragging(false);
                            }}
                            onDrop={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                const file = e.dataTransfer.files[0];
                                const validTypes = ['image/jpeg', 'image/png'];
                                if (!validTypes.includes(file.type)) {
                                    // setError("Only JPG and PNG files are allowed.");
                                    setIsImageDragging(false)
                                    return;
                                }
                                if (file && file?.type.startsWith('image/')) {
                                    const reader = new FileReader();
                                    reader.onloadend = () => {
                                        setSelectedImage(reader.result);
                                        setShowCropper(true);
                                    };
                                    reader.readAsDataURL(file);
                                }
                                setIsImageDragging(false);
                            }}>
                            <div className='image-upload-text-title'><span>Click to upload </span>or drag and drop</div>
                            <div className='image-upload-text-description'>SVG, PNG, JPG or GIF (max. 800x400px)</div>
                        </div>
                        {errorMessage?.imageErrorMessage && <p className="error-message update-input-error">{errorMessage?.imageErrorMessage}</p>}
                    </div>
                </div>
                <div className='save-button-group'>
                    <div className='cancel-button'>Cancel</div>
                    <button
                        className={`save-button button ${isSaveLoading ? 'btn_loading' : ''
                            }`}
                        onClick={() => { handleSave(); }}
                    >
                        {isSaveLoading ? (
                            <div className="registerLoader">
                                <div className="ring-loader"></div>
                            </div>
                        ) : (
                            'Save'
                        )}
                    </button>

                </div>
            </div>
            {showCropper && selectedImage && (
                <ImageEditorBox
                    src={selectedImage}
                    onClose={() => {
                        setShowCropper(false);
                        if (profileInputRef.current) {
                            profileInputRef.current.value = '';
                        }
                    }}
                    onCropDone={handleCropDone}
                    profileInputRef={profileInputRef}
                    isImageLoading={isImageLoading}
                />
            )}
        </>
    )
}

export default General